import React, { useEffect, useRef } from "react"
import PropTypes from "prop-types"
import Image from "../../UI/Image/Image"
import * as styles from "./ModalWrapper-tw-styles"
import useSwipe from "../../../hooks/useSwipe"

const ModalWrapper = props => {
  const {
    closeModal, open, children, variant, image, closeBtnLabel,
    closeOnBodyclick, closeOnEscKeyPress = true, containerEleId, onSwipeRight
  } = props
  const style = styles[variant] || styles.defaultStyle
  const swipeHandlers = useSwipe({ onSwipeRight })
  const containerEleRef = useRef()

  const handleCloseOnKeyPress = event => {
    if ((event.key === "Escape" || event.key === "Esc") && closeOnEscKeyPress) {
      closeModal()
    }
  }
  const onClick = (e) => {
    if (closeOnBodyclick && e.target === e.currentTarget) {
      closeModal()
    }
  }
  useEffect(() => {
    document.addEventListener("keydown", handleCloseOnKeyPress)

    return () => {
      document.removeEventListener("keydown", handleCloseOnKeyPress)
    }
  }, [])

  // Automatically giving focus to the element when it's open
  useEffect(() => {
    if (open) {
      containerEleRef.current.focus()
    }
  }, [open])
  
  return (

    <><div className={`${style?.modalwrpr} ${open ? style?.active : ""}`} onClick={onClick} {...swipeHandlers} data-testid="modal-wrapper">

      <div id={containerEleId} ref={containerEleRef} className={style?.modalContainer} tabIndex={"-1"} data-testid="modal-content">
        {closeBtnLabel &&
          <button className={style?.closeBtn}
            data-testid="closeBtn"
            onClick={closeModal}>{closeBtnLabel}</button>}
        {children}
        {image && <Image
          className={style?.closeBtn}
          contentfulImage={image}
          onClick={closeModal} />}
      </div>
    </div><div className={style?.trendModalContainer}></div></>
  )
}

ModalWrapper.propTypes = {
  open: PropTypes.bool,
  containerEleId: PropTypes.string,
  closeBtnLabel: PropTypes.string,
  closeModal: PropTypes.func,
  children: PropTypes.any,
  variant: PropTypes.string,
  closeOnBodyclick: PropTypes.bool,
  image: PropTypes.object,
  closeOnEscKeyPress: PropTypes.bool,
  onSwipeRight: PropTypes.func
}

export default ModalWrapper
